import {gql} from "@apollo/client";

export const GET_VENUES_QUERY = gql`
query Venues($page: Int, $pageSize: Int) {
  venues(page: $page, pageSize: $pageSize) {
    objects {
        id
        name
        description
        address
        city
        state
        country
        latitude
        longitude
        fields{
            id
            name
            description
        }
        createdBy{
            email
        }
    }
    page
    pages
    hasNext
    hasPrev
  }
}

`;

export const CREATE_VENUE = gql`
mutation CreateVenue($input: CreateSportFacilityInput!){
    createVenue(input: $input){
        venue {
            id
            name
            description
            address
            city
            state
            country
            latitude
            longitude
            fields{
                id
                name
                description
            }
            createdBy{
                email
            }
        }
    }
}
`;

export const UPDATE_VENUE = gql`
  mutation UpdateVenue($id: Int!, $input: CreateSportFacilityInput!) {
    updateVenue(id: $id, input: $input) {
      venue {
        id
        name
        description
        address
        city
        state
        country
        latitude
        longitude
        fields{
            id
            name
            description
        }
        createdBy{
            email
        }
      }
    }
  }
`;

export const DELETE_VENUE = gql`
  mutation DeleteVenue($id: Int!) {
    deleteVenue(id: $id) {
      success
    }
  }
`;